import { getSmsClient } from '@/services/sms'

const smsAxios = getSmsClient()
const baseEndpoint = '/work-order-plans'

export const getWorkOrderPlans = (params = {}) =>
  smsAxios({
    method: 'GET',
    url: baseEndpoint,
    params,
  })

export const getWorkOrderPlan = (id) =>
  smsAxios({
    method: 'GET',
    url: `${baseEndpoint}/${id}`,
  })

export const createWorkOrderPlan = (data) =>
  smsAxios({
    method: 'POST',
    url: baseEndpoint,
    data,
  })

export const updateWorkOrderPlan = (id, data) =>
  smsAxios({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}`,
    data,
  })

export const deleteWorkOrderPlans = (id) =>
  smsAxios({
    method: 'DELETE',
    url: `${baseEndpoint}/${id}`,
  })
